import { render, staticRenderFns } from "./AuthenLayout.vue?vue&type=template&id=67c568ca&scoped=true&"
import script from "./AuthenLayout.vue?vue&type=script&lang=js&"
export * from "./AuthenLayout.vue?vue&type=script&lang=js&"
import style0 from "./AuthenLayout.vue?vue&type=style&index=0&id=67c568ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c568ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
